module.exports = __webpack_public_path__ + "static/media/activity-question.564c7983.png";